import { Link } from "react-router-dom";
import Logo from "../../icon/logo_black.png"
import Manual from '../../ifile/Гарын-авлага.pdf';
import RequestData from "../request/page"
const Header=()=>{
    return(
        <div className="bg-white border-b border-b-slate-300 font-semibold cursor-pointer text-black shadow-xl">
            <div className="container mx-auto flex flex justify-between items-center py-2">
                {/* <Link
                to="/">
                    <img
                        width={250}
                        height={250}
                         className='w-24 lg:w-52 sm:w-32'
                        src={Logo}
                    />
                </Link> */}
                <div className="flex items-center pt-2 pb-4 hidden xl:flex">
                    <Link href={"#"}>
                        <img
                            width={100}
                            height={100}
                                className="w-16 mr-2"
                            src={Logo}
                        />
                    </Link>
                        <div>
                        <p className="font-semibold text-xs text-blue-950">
                            МОНГОЛ УЛСЫН ЗАСГИЙН ГАЗАР
                        </p>
                        <p className="font-semibold text-xs sm:text-sm leading-tight text-black">
                            ЦАГ УУР, ОРЧНЫ ШИНЖИЛГЭЭНИЙ ГАЗАР
                        </p>
                    </div>

                </div>

                <div className="flex flex-col sm:flex-row items-center text-black text-md">
                    <RequestData/>

                    <div className="sm:border-r sm:border-r-slate-500">
                        <a type="application/pdf" target="_blank" className="hover:text-blue-800 py-2 px-4 rounded-lg hover:text-white" href={Manual}>Гарын авлага</a>
                    </div>
                    <div>
                        <Link
                            to="/login">
                            <div className="hover:text-blue-800 py-2 pl-4 rounded-lg hover:text-white">Нэвтрэх</div>
                        </Link>
                    </div>
                </div>
           
            </div>
        </div>
    )

}

export default Header;